import React, { useEffect, useMemo } from 'react'
// import { CameraResetButton, CustomisationResetButton } from './index'
import styled from 'styled-components'

const Dock = ({ top = "auto", left = "auto", bottom = "auto", right = "auto", minW = "100px", column = true, children }) => {

    return (
        <Wrap $top={top} $bottom={bottom} $left={left} $column={column} $right={right} $minW={minW} id="button-tray" >
            {children}
        </Wrap>
    )
}

export default Dock


const Wrap = styled.div`
position: absolute;
right: ${(props) => (props.$right)};
left: ${(props) => (props.$left)};
bottom: ${(props) => (props.$bottom)};
top: ${(props) => (props.$top)};
min-width: ${(props) => (props.$minW)};
/* width: 200px; */
z-index: 800;
display: flex;
flex-direction: ${(props) => (props.$column ? "column" : "row")};
justify-content: end;
align-items: center;
gap: 20px;
`